import { Pipe, PipeTransform, QueryList } from '@angular/core';
import { CellTemplateDirective } from '../directives/cell-template.directive';
import { DataTableColumn } from '../models';

@Pipe({
    name: 'findCellTemplate',
    standalone: false
})
export class FindCellTemplatePipe<T> implements PipeTransform {
    transform(templates: QueryList<CellTemplateDirective<T>>, column: DataTableColumn): CellTemplateDirective<T> {
        return templates?.find((template: CellTemplateDirective<T>) => template.name === column.cellTemplate);
    }
}
